export default __webpack_public_path__ + "f8b6fcbee5c33947b208082df3a967e8.png";